<template>
    <div class="dashboard">
        <GridFilter />
        <GridLegend />
        <Grid/>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Grid from '@/components/Grid.vue'
    import GridFilter from '@/components/GridFilter.vue'
    import GridLegend from '@/components/GridLegend.vue'

    export default {
        name: 'Dashboard',
        components: {
            Grid,
            GridFilter,
            GridLegend,
        }
    }
</script>
